import { getLanguagesApiUrl, type Environment } from './config'

export interface Language {
  code: string
  label: string
  localLabel: string
}

export interface LanguagesResponse {
  default: string
  languages: Language[]
}

export const fetchLanguages = async (
  env: Environment = 'tst',
): Promise<LanguagesResponse> => {
  const url = getLanguagesApiUrl(env)

  const response = await fetch(url, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
    mode: 'cors',
    credentials: 'omit',
  })

  if (!response.ok) {
    const message = await response.text()
    throw new Error(message || 'Failed to fetch languages')
  }

  return response.json()
}
